<!--
* 首页
* @authors zzt
* @date 2019-01-18
* @version 1.0
-->
<template>
  <div class="homecontent" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="50">
    <Banner></Banner>
    <!-- 楼层引导 -->
    <div ref="guideBox">
      <div class="guide" :style="isFixedStyle">
        <div class="guide-left" ref="guide">
          <a @click="changeHash(1)"  id="#box-one">
            <span class="title-one">1F</span>
            <span :class="currentCheck=='box1' ? 'isCheckeds' :'title-two'">工程工队</span>
          </a>
          <a @click="changeHash(2)"  id="#box-two">
            <span class="title-one">2F</span>
            <span  :class="currentCheck=='box2' ? 'isCheckeds' :'title-two'">临时用工</span>
          </a>
          <a @click="changeHash(3)"  id="#box-three">
            <span class="title-one">3F</span>
            <span  :class="currentCheck=='box3' ? 'isCheckeds' :'title-two'">工种报价</span>
          </a>
          <a @click="changeHash(4)"  id="#box-four">
            <span class="title-one">4F</span>
            <span  :class="currentCheck=='box4' ? 'isCheckeds' :'title-two'">劳务用工</span>
          </a>
          <a @click="changeHash(5)"  id="#box-five">
            <span class="title-one">5F</span>
            <span  :class="currentCheck=='box5' ? 'isCheckeds' :'title-two'">专业工人</span>
          </a>
          <a @click="changeHash(6)"  id="#box-six">
            <span class="title-one">6F</span>
            <span  :class="currentCheck=='box6' ? 'isCheckeds' :'title-two'">知识分享</span>
          </a>
        </div>
      </div>
    </div>
    
    <div id="box-one" ref="box1" v-if="shouModules >= 1">
      <team></team>
    </div>
    <div id="box-two" ref="box2" v-if="shouModules >= 2">
      <flexibleEmployment></flexibleEmployment>
    </div>
    <div id="box-three" ref="box3"  v-if="shouModules >= 3">
      <volunteerTeamOffer></volunteerTeamOffer>
    </div>
    <div id="box-four" ref="box4" v-if="shouModules >= 4">
      <labour></labour>
    </div>
    <div id="box-five" ref="box5" v-if="shouModules >= 5">
      <worker></worker>
    </div>
    <div id="box-six" ref="box6" v-if="shouModules >= 6">
      <technologyShare></technologyShare>
    </div>
  <!-- 左边导航栏 -->
  <div class="LeftNav">
    <div class="leftNav-name text-center">
      <div class="Navigation">导航</div>
    </div>
    <div class="leftNav-navs">
      <div class="leftNav-nav" @click="changeHash(1)">
        <div class="text-center"><span>工程工队</span></div>
      </div>
      <div class="leftNav-nav" @click="changeHash(2)">
        <div class="text-center"><span>临时用工</span></div>
      </div>
      <div class="leftNav-nav" @click="changeHash(3)">
        <div class="text-center"><span>工种报价</span></div>
      </div>
      <div class="leftNav-nav" @click="changeHash(4)">
        <div class="text-center"><span>劳务用工</span></div>
      </div>
      <div class="leftNav-nav" @click="changeHash(5)">
        <div class="text-center"><span>专业工人</span></div>
      </div>
      <div class="leftNav-nav" @click="changeHash(6)">
        <div class="text-center"><span>技术分享</span></div>
      </div>
      <div class="leftNav-nav" @click="goTo('gcfb')">
        <div class="text-center"><span>工程分包</span></div>
      </div>
      <div class="leftNav-nav" @click="goTo('lwgs')">
        <div class="text-center"><span>劳务公司</span></div>
      </div>
      <div class="leftNav-nav" @click="goTo('rqgd')">
        <div class="text-center"><span>人气工队</span></div>
      </div>
    </div>
    <div  class="leftNav-top" @click="scrollTop">
        <div class="text-centers">回顶部</div>
    </div>
  </div>
  </div>
</template>

<script>
import EventBus from "@/util/event-bus"
export default {
  name: "home",
  components: {
    Banner: () => import("@/views/Home/components/RedesignBanner"), // 轮播图
    team: () =>import("@/views/Home/HomeContent/team"), // 首页施工工队
    flexibleEmployment: () => import("@/views/Home/HomeContent/flexibleEmployment.vue"), // 首页临时用工
    volunteerTeamOffer: () => import("@/views/Home/HomeContent/volunteerTeamOffer.vue"), // 首页工种报价
    labour:()=>import("@/views/Home/HomeContent/labour.vue"), // 首页劳务用工
    worker:()=>import("@/views/Home/HomeContent/worker.vue"), // 首页专业工人
    technologyShare:()=>import("@/views/Home/HomeContent/technologyShare.vue"), // 首页技术分享
  },
  data: function() {
    return {
      dataList: [],
      isFixed: false,
      SCROLLHEIGHT:639,
      currentCheck:'',
      shouModules: 1, // 设置成数字可以更简单的控制组件的显示隐藏
      busy: false,
      removeScroll: false,
      firstFloorSwitch: true,
      index2actived: false // index2是否在index3之前点击
    }
  },
  computed: {
    isFixedStyle({ isFixed }) {
      if (isFixed) {
        return {
          position: "fixed",
          top: 0
        };
      };
      return '';
    }
  },
  methods: {
    goTo(name){
      let routeUrl=''
      if(name=='gcfb'){
        routeUrl = `/zb`;
      }else if(name=='lwgs'){
        routeUrl = `/LaborServiceCompany`;
      }else if(name=='rqgd'){
        routeUrl = `/popularityTeam`;
      }
      this.$router.push(routeUrl)
    },
    // 滚动加载更多模块
    loadMore() {
      this.busy = true;
      this.shouModules += 1;
      this.busy = this.shouModules > 6;
    },
    handleScroll() {
      // this.isFixed = this.$refs.guideBox.getBoundingClientRect().top <= 0;
      this.isFixed = (document.documentElement.scrollTop || document.body.scrollTop) > this.SCROLLHEIGHT;
      // let box2Height = this.$refs.box2.offsetTop;
      // let box3Height = this.$refs.box3.offsetTop;
      // let box4Height = this.$refs.box4.offsetTop;
      // let box5Height = this.$refs.box5.offsetTop;
      // let box6Height = this.$refs.box6.offsetTop;
      //
      // 获取屏幕高度
      // this.isFixed = scrollTop > this.SCROLLHEIGHT;
      // if(scrollTop>=this.SCROLLHEIGHT && scrollTop<this.SCROLLHEIGHT+window.screen.availHeight/2){
      //   this.currentCheck="box1"
      // }
      // else if(scrollTop>=this.SCROLLHEIGHT+window.screen.availHeight/2 && scrollTop<box3Height-window.screen.availHeight/2){
      //   this.currentCheck="box2"
      // }
      // else if(scrollTop>=box3Height-window.screen.availHeight/2  && scrollTop<box4Height-window.screen.availHeight/2){
      //   this.currentCheck="box3"
      // }
      // else if(scrollTop>=box4Height-window.screen.availHeight/2 && scrollTop<box5Height-window.screen.availHeight/2){
      //    this.currentCheck="box4"
      // }
      // else if(scrollTop>=box5Height-window.screen.availHeight/2 && scrollTop<box6Height-window.screen.availHeight/2 ){
      //   this.currentCheck="box5"
      // }
      // else if(scrollTop>=box6Height-window.screen.availHeight/2){
      //   this.currentCheck="box6"
      // }
      // else {
      //   this.currentCheck=""
      // }
      // if(scrollTop>=this.SCROLLHEIGHT && scrollTop<box2Height-60){
      //   this.currentCheck="box1"
      // }
      // else if(scrollTop>=box2Height-60 && scrollTop<box3Height-60){
      //   this.currentCheck="box2"
      // }
      // else if(scrollTop>=box3Height-60 && scrollTop<box4Height-60){
      //   this.currentCheck="box3"
      // }
      // else if(scrollTop>=box4Height-60 && scrollTop<box5Height-60){
      //    this.currentCheck="box4"
      // }
      // else if(scrollTop>=box5Height-60 && scrollTop<box6Height-60){
      //   this.currentCheck="box5"
      // }
      // else if(scrollTop>=box6Height-60){
      //   this.currentCheck="box6"
      // }
      // else {
      //   this.currentCheck=""
      // }
    },
    scrollListener() {
      this.$nextTick(() => {
        try {
          document.addEventListener("scroll", () => {
            const dom1 = this.$refs[`box1`];
            const dom2 = this.$refs[`box2`];
            const dom3 = this.$refs[`box3`];
            const dom4 = this.$refs[`box4`];
            const dom5 = this.$refs[`box5`];
            const dom6 = this.$refs[`box6`];
            if (this.removeScroll) return;
            if (
              dom1 &&
              dom1.getBoundingClientRect().top <=
              dom1.getBoundingClientRect().height / 2
            ) {
              this.currentCheck = "box1";
            }
            if (
              dom2 &&
              dom2.getBoundingClientRect().top <=
              dom2.getBoundingClientRect().height / 2
            ) {
              this.currentCheck = "box2";
            }
            if (
              dom3 &&
              dom3.getBoundingClientRect().top <=
              dom3.getBoundingClientRect().height / 2
            ) {
              this.currentCheck = "box3";
            }
            if (
              dom4 &&
              dom4.getBoundingClientRect().top <=
              dom4.getBoundingClientRect().height / 2
            ) {
              this.currentCheck = "box4";
            }
            if (
              dom5 &&
              dom5.getBoundingClientRect().top <=
              dom5.getBoundingClientRect().height / 2
            ) {
              this.currentCheck = "box5";
            }
            if (
              dom6 &&
              dom6.getBoundingClientRect().top <=
              dom6.getBoundingClientRect().height / 2
            ) {
              this.currentCheck = "box6";
            }
          });
        } catch (error) {
          console.log(error);
        }
      });
    },
    // getHeight(){
    //   this.SCROLLHEIGHT=630;
    // },
    changeHash(index){
      //  document.querySelector(idname).scrollIntoView(true);
      // this.currentCheck = `box${index}`;
      // let Height = this.$refs[`box${index}`].offsetTop;
      // window.scrollTo({
      //   top: Height - 40
      // })

      this.removeScroll = true;
      const promise = new Promise((resolve, reject) => {
        if(this.shouModules < index + 1){
          this.shouModules = index + 1;
        }

        // 首次点击index > 2的tab
        if(this.firstFloorSwitch && index > 2) {
          this.firstFloorSwitch = false;
          setTimeout(() => {
            this.$nextTick(() => {
              const dom = this.$refs[`box${index}`];
              this.currentCheck = `box${index}`;

              let distance;
              if(index == 3) distance = this.index2actived ? 138 : 675;

              window.scrollTo({
                top: dom.offsetTop + (index == 3 ? distance : index == 4 ? 636 : index == 5 ? 606 : 138)
              });
              this.index2actived = false;
              return resolve();
            })
          }, 40)
        }

        if(this.firstFloorSwitch && index == 2) {
          this.index2actived = true;
        }

        this.$nextTick(() => {
          const dom = this.$refs[`box${index}`];
          this.currentCheck = `box${index}`;
          window.scrollTo({
            top: dom.offsetTop + 138
          });
          return resolve();
        })
      });
      promise.then(() => {
        setTimeout(() => {
          this.removeScroll = false;
        }, 1000);
      });
    },
      //点击左边导航栏滑动到顶部
    scrollTop() {
      // 加入定时器让他又快到慢滚动到顶部
      let timer = setInterval(() => {
        // 获取当前scrollTop的高度位置（兼容ie和chrom浏览器）
        let oTop = document.documentElement.scrollTop || document.body.scrollTop
        // 设置速度由快到慢
        let ispeed = Math.floor(-oTop / 3)
        document.documentElement.scrollTop = document.body.scrollTop =
          oTop + ispeed
        if (oTop === 0) {
          clearInterval(timer)
        }
      }, 30)
    },
  },
  mounted() {
    // this.getHeight()
    //监听滚动条事件
    window.addEventListener("scroll", this.handleScroll)
    setTimeout(() => {
      this.scrollListener();
    }, 1000);
  },
  created() {
    EventBus.$emit("reload")
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
.LeftNav {
    position: fixed;
    top: 200px;
    left: 50%;
    width: 60px;
    -webkit-transform: translateX(-680px);
    transform: translateX(-680px);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff!important;
  .text-center{
    position: relative;
    span {
    position: absolute;
    width: 2em;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    }
  }
  .leftNav-name{
    height: 61px;
    background:url("../../assets/sidebar/daohang-lefts.png") 15px 7px no-repeat;
    background-size: 30px 30px;
    background-color: #df361b;
    border-bottom: 1px solid #fff;
    .Navigation{
      padding-top:36px;
      text-align:center;
      font-size: 12px;
    }
  }
  .leftNav-navs {
    background: #999;
    .leftNav-nav {
      border-width: 15px;
      padding: 0 ;
      cursor: pointer;
      &:hover{
        background-color: #b79255;
      }
    }
    .leftNav-nav>div{
      width: 100%;
      height: 60px;
      border-bottom: 1px solid #fff;
    }
  }
  .leftNav-top {
    height: 61px;
    width: 100%;
    background:url("../../assets/sidebar/tops.png") 13px 12px no-repeat;
    background-size: 32px 20px;
    background-color: #ccc;
    cursor: pointer;
    .text-centers{
    text-align: center;
    padding-top: 33px;
    font-size: 13px;
  }
  }
}
@media screen and (max-height: 900px) {
  .LeftNav {
    position: fixed;
    top: 200px;
    left: calc(50% + 10px);
    width: 52px;
    -webkit-transform: translateX(-680px);
    transform: translateX(-680px);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff!important;
  .text-center{
    position: relative;
    span {
    position: absolute;
    width: 2em;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    }
  }
  .leftNav-name{
    height: 52px;
    background:url("../../assets/sidebar/daohang-lefts.png") 13px 5px no-repeat;
    background-size: 25px 25px;
    background-color: #df361b;
    border-bottom: 1px solid #fff;
    .Navigation{
      padding-top:30px;
      text-align:center;
      font-size: 12px;
    }
  }
  .leftNav-navs {
    background: #999;
    .leftNav-nav {
      border-width: 15px;
      padding: 0 ;
      cursor: pointer;
      &:hover{
        background-color: #b79255;
      }
    }
    .leftNav-nav>div{
      width: 100%;
      height: 52px;
      border-bottom: 1px solid #fff;
    }
  }
  .leftNav-top {
    height: 52px;
    width: 100%;
    background:url("../../assets/sidebar/tops.png") 10px 6px no-repeat;
    background-size: 32px 20px;
    background-color: #ccc;
    cursor: pointer;
    .text-centers{
    text-align: center;
    padding-top: 28px;
    font-size: 13px;
  }
  }
}
}
.homecontent {
  position: relative;
  .guide {
    position: absolute;
    top: 460px;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 0 !important;
    z-index: 99;
    width: 1200px;
    height: 40px;
    background: #ffffff;
    margin: 10px auto 0;
    display: flex;
    align-items: center;
    box-shadow: 0 1px 3px rgba(18, 18, 18, 0.1);
    .guide-left {
      display: flex;
      color: #333;
      cursor: pointer;
      .title-one {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #b79255;
        padding-right: 8px;
      }
      .title-two {
        font-size: 14px;
      }
      .isCheckeds {
       color: #B79255;
       font-size: 18px;
       font-weight: bold;
       font-family: Microsoft YaHei;
      }
    }
    a {
      color: #5e5e5e;
      height: 24px;
      line-height: 24px;
      margin: 10px 0px 10px 30px;
      padding-right: 30px;
      border-right: 1px solid #e4e7ed;
      &:last-child {
        border-right: none;
      }
    }
    .input {
      display: flex;
      align-items: center;
      flex: 1;
      // background-color: #c6a56f;
      .searchbuttom {
        color: #fff;
        width: 60px;
        // border-radius: 0 4px 4px 0;
        // overflow: hidden;
        height: 40px;
        line-height: 40px;
        background-color: #e1251b;
        padding: 0px;
      }
      .el-input {
        width: 196px;
        line-height: 30px !important;
        margin-left: 120px;
        .el-input__inner {
          height: 30px !important;
        }
      }
    }
  }
}
.tc-10 {
  height: 10px;
}
.tc-20 {
  height: 20px;
}
.tc-30 {
  height: 30px;
}
.tc-52 {
  height: 52px;
}
.advertising_cont {
  width: 1200px;
  margin: 0 auto;
  height: 100px;
  img {
    width: 100%;
    height: 100%;
  }
}
/deep/.el-icon-caret-top:before{margin-left: 5px;}
/deep/.el-icon-caret-bottom:before{margin-left: 5px;}
</style>
